import { isNative } from "@cntrl/native";

/**
 * May this surface offer a way to PAY US — checkout, a plan change, cancel/resume, a promo code? (ART-346, PO
 * 2026-10-29: no payments at all from inside the app.) False inside the native app, where App Review allows no
 * purchase path outside in-app purchase; there a surface states the fact (the plan name, "isn't active") and offers
 * no button, link or price. Payments that are not purchases from us — Venmo payouts, a band's own Meta ad budget —
 * are not covered and stay.
 *
 * The ONE predicate every billing surface asks, so a new purchase door has one place to be withheld from.
 */
export function canPurchaseHere(): boolean {
  return !isNative();
}
